import type { CommentStatus, CommunityReply } from '../types/community';

export function formatCommentDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function getCommentStatusLabel(status: CommentStatus): string {
  switch (String(status).toLowerCase()) {
    case 'approved':
      return 'مقبول';
    case 'pending':
      return 'قيد المراجعة';
    case 'rejected':
      return 'مرفوض';
    case 'draft':
      return 'مسودة';
    default:
      return String(status);
  }
}

export function getCommentStatusStyle(status: CommentStatus): string {
  switch (String(status).toLowerCase()) {
    case 'approved':
      return 'bg-primary-light text-primary-dark';
    case 'pending':
      return 'bg-sage-50 text-sage-700 border border-sage-200';
    case 'rejected':
      return 'bg-red-50 text-red-700';
    default:
      return 'bg-sage-50 text-primary-dark';
  }
}

export function getReplyDisplayName(reply: CommunityReply): string {
  return reply.moderatorName || reply.studentName || 'رد';
}
